import { PermissionBits } from "src/app/core/services/constants";
import { MenuItem } from "../sidebar/menu.model";

export enum MENUIDS {
  APPBUILDER = 1,
  APPBUILDERBRANDING,
  APPBUILDERNAVIGATION,
  APPBUILDERSIDE,
  APPBUILDERSETTINGS,
  APPBUILDERBUILD,
  DASHBOARD,
  MESSAGES,
  CHANNELS,
  CHATMANGER,
  CHAT,
  CHATSCHEDULE,
  CHATGROUPS,
  NOTIFICATION,
  NOTIFICATIONS,
  NOTIFICATIONTEMPLATE,
  POLLS,
  PAGES,
  ARTICLE,
  GROUPS,
  MOBILECOMMERCE,
  STORES,
  COLLECTIONS,
  PRODUCTS,
  ORDERMANAGEMENT,
  ORDERS,
  BOOKINGANDEVENTS,
  MARKET,
  BOOKINGS,
  CATEGORIES,
  EVENTS,
  CALENDARS,
  USERENGAGEMENT,
  COUPONS,
  LOCATIONS,
  CAMPAIGNS,
  USERMANAGEMENT,
  USERS,
  PARTNERDASHBOARD,
  PARTNER,
  USERSTAGS,
  INTEGRATIONANDAUTOMATION,
  API,
  EXTENSIONS,
  INSTALLED,
  ADMIN,
  ADMINLIST,
  GENERALSETTINGS,
  DEFAULTSETTINGS,
  SIGNUPSETTINGS,
  SETTINGSLIST,
  SIGNUPFILTER,
  WHITELISTANDBLACKLIST,
  TAXSETTING,
  COMMERCESETTINGS,
  SHIPPINGSETTINGS,
  CHATSETTINGS,
  TEMPLATE,
  BULLKUPLOAD,
  SETTINGS,
  CONTENTMANGER,
  CATALOGS,
  CONTENTS,
  EMAIL,
  SMS,
  MARKERCHECKER,
  BRANCHES,
  VENDORS,
  ACCOUNTMENU,
}

export const PermissionMenuMap: { [key: string]: number } = {
  APPBUILDER: PermissionBits.AppBuilder,
  APPBUILDERBRANDING: PermissionBits.AppBuilder,
  APPBUILDERNAVIGATION: PermissionBits.AppBuilder,
  APPBUILDERSIDE: PermissionBits.AppBuilder,
  APPBUILDERSETTINGS: PermissionBits.AppBuilder,
  APPBUILDERBUILD: PermissionBits.AppBuilder,
  DASHBOARD: PermissionBits.Dashboard,
  MESSAGES: PermissionBits.Chat,
  CHANNELS: PermissionBits.Channels,
  CHATMANGER: PermissionBits.Chat,
  CHAT: PermissionBits.Chat,
  CHATSCHEDULE: PermissionBits.Chat,
  CHATGROUPS: PermissionBits.ChatGroups,
  POLLS: PermissionBits.EngagementPolls,
  CONTENTMANGER: PermissionBits.ContentsLevel,
  PAGES: PermissionBits.ContentsLevel,
  ARTICLE: PermissionBits.ContentsLevel,
  GROUPS: PermissionBits.ChatGroups,
  STORES: PermissionBits.MobileCommerceStores,
  COLLECTIONS: PermissionBits.MobileCommerceCollections,
  PRODUCTS: PermissionBits.MobileCommerceProducts,
  ORDERMANAGEMENT: PermissionBits.OrderManagement,
  ORDERS: PermissionBits.OrderManagement,
  MARKET: PermissionBits.BookingMarket,
  BOOKINGS: PermissionBits.BookingBookings,
  CATEGORIES: PermissionBits.BookingCategories,
  EVENTS: PermissionBits.BookingEvents,
  CALENDARS: PermissionBits.Calendar,
  USERENGAGEMENT: PermissionBits.UserManagement,
  COUPONS: PermissionBits.EngagementCoupons,
  USERMANAGEMENT: PermissionBits.UserManagement,
  USERS: PermissionBits.UserManagement,
  USERSTAGS: PermissionBits.Settings,
  INTEGRATIONANDAUTOMATION: PermissionBits.Settings,
  AP: PermissionBits.Settings,
  EXTENSIONS: PermissionBits.Settings,
  INSTALLED: PermissionBits.Settings,
  GENERALSETTINGS: PermissionBits.Settings,
  DEFAULTSETTINGS: PermissionBits.Settings,
  SIGNUPSETTINGS: PermissionBits.Settings,
  SETTINGSLIST: PermissionBits.Settings,
  SIGNUPFILTER: PermissionBits.Settings,
  WHITELISTANDBLACKLIST: PermissionBits.Settings,
  TAXSETTING: PermissionBits.Settings,
  COMMERCESETTINGS: PermissionBits.Settings,
  SHIPPINGSETTINGS: PermissionBits.Settings,
  CHATSETTINGS: PermissionBits.Settings,
  BULLKUPLOAD: PermissionBits.AppBuilder,
  SETTINGS: PermissionBits.Settings,
  PARTNERDASHBOARD: PermissionBits.PartnerDashboard,
  PARTNER: PermissionBits.PartnerLevel,
};

export const MENU: MenuItem[] = [
  {
    isTitle: true,
    label: "App Builder",
    isMain: true,
  },
  {
    id: MENUIDS.APPBUILDER,
    label: "App",
    icon: "smartphone",
    icon_color: "#4ecb69",
    link: "/appbuilder",
    isMain: true,
    subItems: [
      {
        id: MENUIDS.APPBUILDERBRANDING,
        label: "Branding",
        link: "/appbuilder/branding",
        parentId: MENUIDS.APPBUILDER,
        bitOffset: PermissionBits.AppBuilder,
      },
      {
        id: MENUIDS.APPBUILDERNAVIGATION,
        label: "Navigation",
        link: "/appbuilder/navigation",
        parentId: MENUIDS.APPBUILDER,
        bitOffset: PermissionBits.AppBuilder,
      },
      {
        id: MENUIDS.APPBUILDERSIDE,
        label: "Side Menu",
        link: "/appbuilder/side",
        parentId: MENUIDS.APPBUILDER,
        bitOffset: PermissionBits.AppBuilder,
      },
      {
        id: MENUIDS.APPBUILDERSETTINGS,
        label: "App Settings",
        link: "/appbuilder/settings",
        parentId: MENUIDS.APPBUILDER,
        bitOffset: PermissionBits.AppBuilder,
      },
      {
        id: MENUIDS.APPBUILDERBUILD,
        label: "Build",
        link: "/appbuilder/build",
        parentId: MENUIDS.APPBUILDER,
        bitOffset: PermissionBits.AppBuilder,
      },
    ],
  },
  // {
  //   id: MENUIDS.DASHBOARD,
  //   label: "MENUITEMS.DASHBOARD.TEXT",
  //   icon: 'bx bx-home-circle',
  //   link: "/appbuilder",
  // },
  {
    isTitle: true,
    label: "Communication",
  },
  {
    id: MENUIDS.CHAT,
    label: "Chat",
    icon: "comment",
    icon_color: "#349fff",
    subItems: [
      {
        id: MENUIDS.MESSAGES,
        label: "Messages",
        link: "/message",
        parentId: MENUIDS.CHAT,
        bitOffset: PermissionBits.Chat,
      },
      {
        id: MENUIDS.CHATSCHEDULE,
        label: "Schedule",
        link: "/schedule",
        parentId: MENUIDS.CHAT,
        bitOffset: PermissionBits.Chat,
      },

      {
        id: MENUIDS.POLLS,
        label: "Message Menus",
        link: "/polls",
        // icon: "poll",
        // icon_color: "#349fff",
        parentId: MENUIDS.CHAT,
        bitOffset: PermissionBits.EngagementPolls,
      },
      {
        id: MENUIDS.CALENDARS,
        label: "Timetables",
        link: "/calendars",
        icon: "calendar_month",
        icon_color: "#9774ff",
        bitOffset: PermissionBits.Calendar,
      },
    ],
  },
  // {
  //   isTitle: true,
  //   label: "Business Groups",
  // },
  // {
  //   id: MENUIDS.EMAIL,
  //   label: "Email",
  //   icon: 'email',
  //   icon_color: "#fd9452",
  //   link: "/email",
  //   bitOffset: PermissionBits.ChatGroups,
  // },
  // {
  //   id: MENUIDS.SMS,
  //   label: "SMS",
  //   icon: 'sms',
  //   icon_color: "#fd9452",
  //   link: "/sms",
  //   bitOffset: PermissionBits.ChatGroups,
  // },
  // {
  //   id: MENUIDS.NOTIFICATION,
  //   label: "Notification",
  //   icon: "comment",
  //   icon_color: "#349fff",
  //   subItems: [
  //     {
  //       id: MENUIDS.NOTIFICATIONS,
  //       label: "Notifications",
  //       link: "/notifications",
  //       parentId: MENUIDS.NOTIFICATION,
  //       bitOffset: PermissionBits.Chat,
  //     },
  //   ]
  // },
  {
    id: MENUIDS.CHATGROUPS,
    label: "Groups",
    icon: "groups",
    icon_color: "#fd9452",
    link: "/groups",
    bitOffset: PermissionBits.ChatGroups,
  },
  {
    id: MENUIDS.CHANNELS,
    label: "Channels",
    icon: "rss_feed",
    icon_color: "#b6cd70",
    link: "/channels",
    bitOffset: PermissionBits.Channels,
  },
  // {
  //   isTitle: true,
  //   label: "Schedule",
  // },

  {
    isTitle: true,
    label: "Business Structure",
  },
  {
    id: MENUIDS.VENDORS,
    label: "Vendors",
    icon: "storefront",
    icon_color: "#E5533D",
    link: "/vendors",
    bitOffset: PermissionBits.VendorControl,
  },
  // {
  //   id: MENUIDS.BRANCHES,
  //   label: "Branches",
  //   icon: "account_tree",
  //   icon_color: "#2ECC71",
  //   link: "/branches",
  //   bitOffset: PermissionBits.VendorControl,
  // },
  {
    isTitle: true,
    label: "Commerce & Services",
  },
  {
    id: MENUIDS.MOBILECOMMERCE,
    label: "Mobile Commerce",
    icon: "shopping_cart",
    icon_color: "#fd8888",
    subItems: [
      {
        id: MENUIDS.STORES,
        label: "Stores",
        link: "/stores",
        parentId: MENUIDS.MOBILECOMMERCE,
        bitOffset: PermissionBits.MobileCommerceStores,
      },
      {
        id: MENUIDS.COLLECTIONS,
        label: "MENUITEMS.COMMERCE.LIST.COLLECTIONS",
        link: "/collections",
        parentId: MENUIDS.MOBILECOMMERCE,
        bitOffset: PermissionBits.MobileCommerceCollections,
      },
      {
        id: MENUIDS.PRODUCTS,
        label: "MENUITEMS.COMMERCE.LIST.PRODUCTS",
        link: "/products",
        parentId: MENUIDS.MOBILECOMMERCE,
        bitOffset: PermissionBits.MobileCommerceProducts,
      },
    ],
  },
  {
    id: MENUIDS.BOOKINGANDEVENTS,
    label: "MENUITEMS.BOOKINGANDEVENTS.TEXT",
    icon: "confirmation_number",
    icon_color: "#5671ff",
    subItems: [
      {
        id: MENUIDS.MARKET,
        label: "Market",
        link: "/market",
        parentId: MENUIDS.BOOKINGANDEVENTS,
        bitOffset: PermissionBits.BookingMarket,
      },
      {
        id: MENUIDS.CATEGORIES,
        label: "Categories",
        link: "/categories",
        parentId: MENUIDS.BOOKINGANDEVENTS,
        bitOffset: PermissionBits.BookingCategories,
      },
      {
        id: MENUIDS.BOOKINGS,
        label: "Bookings",
        link: "/bookings",
        parentId: MENUIDS.BOOKINGANDEVENTS,
        bitOffset: PermissionBits.BookingBookings,
      },
      {
        id: MENUIDS.EVENTS,
        label: "Events",
        link: "/events",
        parentId: MENUIDS.BOOKINGANDEVENTS,
        bitOffset: PermissionBits.BookingEvents,
      },
    ],
  },

  {
    id: MENUIDS.ORDERMANAGEMENT,
    label: "Order Management",
    icon: "paid",
    icon_color: "#ffd96a",
    subItems: [
      {
        id: MENUIDS.ORDERS,
        label: "MENUITEMS.COMMERCE.LIST.ORDERS",
        link: "/payment-orders",
        parentId: MENUIDS.MOBILECOMMERCE,
        bitOffset: PermissionBits.OrderManagement,
      },
    ],
  },

  {
    isTitle: true,
    label: "Media & Content",
  },
  {
    id: MENUIDS.CONTENTMANGER,
    label: "Media Library",
    icon: "add_a_photo",
    icon_color: "#fd8888",
    subItems: [
      {
        id: MENUIDS.CATALOGS,
        label: "Catalogs",
        link: "/catalogs",
        parentId: MENUIDS.CONTENTMANGER,
        bitOffset: PermissionBits.ContentsLevel,
      },
      {
        id: MENUIDS.CONTENTS,
        label: "Contents",
        link: "/contents",
        parentId: MENUIDS.CONTENTMANGER,
        bitOffset: PermissionBits.ContentsLevel,
      },
    ],
  },
  {
    isTitle: true,
    label: "Users",
  },
  {
    id: MENUIDS.USERS,
    label: "User Management",
    icon: "manage_accounts",
    icon_color: "#3ce7ea",
    link: "/users",
    bitOffset: PermissionBits.UserManagement,
  },
  {
    id: MENUIDS.ACCOUNTMENU,
    label: "User Form",
    icon: "manage_accounts",
    icon_color: "#3ce7ea",
    link: "/user-form",
    bitOffset: PermissionBits.UserManagement,
  },
  {
    isTitle: true,
    label: "Approvals",
  },
  {
    id: MENUIDS.MARKERCHECKER,
    label: "Requests",
    icon: "fact_check",
    icon_color: "#F59E0B",
    link: "/maker-checker",
    bitOffset: PermissionBits.Approvals,
  },
   {
    isTitle: true,
    label: "Engagement",
  },
  {
    id: MENUIDS.USERENGAGEMENT,
    label: "Engagements",
    icon: "thumb_up",
    icon_color: "#cbf078",
    subItems: [
      {
        id: MENUIDS.COUPONS,
        label: "MENUITEMS.USERENGAGEMENT.LIST.COUPONS",
        link: "/coupons",
        parentId: MENUIDS.USERENGAGEMENT,
        bitOffset: PermissionBits.EngagementCoupons,
      },
    ],
  },
  {
    isTitle: true,
    label: "Partner Hub",
  },

  {
    id: MENUIDS.PARTNERDASHBOARD,
    label: "Partner Dashboard",
    icon: "insights",
    icon_color: "#5bc0be",
    link: "/partners/home",
    bitOffset: PermissionBits.PartnerDashboard,
  },
  {
    id: MENUIDS.PARTNER,
    label: "App Management",
    icon: "apps",
    icon_color: "#9d7bf8",
    link: "/partners/apps",
    bitOffset: PermissionBits.PartnerLevel,
  },

  // {
  //   id: MENUIDS.CAMPAIGNS,
  //   label: "MENUITEMS.USERENGAGEMENT.LIST.CAMPAIGNS",
  //   link: "/campaigns",
  //   parentId: MENUIDS.USERENGAGEMENT,
  // },
  // {
  //   id: MENUIDS.LOCATIONS,
  //   label: "Locations",
  //   icon: 'location_on',
  //   icon_color: "#3ce7ea",
  //   link: "/locations",
  // },
  // {
  //   isTitle: true,
  //   label: "Integrations"
  // },
  // {
  //   id: MENUIDS.INTEGRATIONANDAUTOMATION,
  //   label: "MENUITEMS.INTEGRATIONANDAUTOMATION.TEXT",
  //   icon: "bx bxs-user-detail",
  //   subItems: [
  // {
  //   id: MENUIDS.CHATBOT,
  //   label: "MENUITEMS.INTEGRATIONANDAUTOMATION.LIST.CHATBOT",
  //   link: "/bots",
  //   parentId: MENUIDS.INTEGRATIONANDAUTOMATION,
  // },
  //     {
  //       id: MENUIDS.API,
  //       label: "MENUITEMS.INTEGRATIONANDAUTOMATION.LIST.API",
  //       link: "/api",
  //       parentId: MENUIDS.INTEGRATIONANDAUTOMATION,
  //     },
  //   ],
  // },
  // {
  //   id: MENUIDS.EXTENSIONS,
  //   label: "MENUITEMS.EXTENSIONS.TEXT",
  //   icon: "extension",
  //   icon_color: "#1abb9c",
  //   subItems: [
  //     {
  //       id: MENUIDS.INSTALLED,
  //       label: "MENUITEMS.EXTENSIONS.LIST.INSTALLED",
  //       link: "/installed",
  //       parentId: MENUIDS.EXTENSIONS,
  //     }
  //   ],
  // },
  // {
  //   id: MENUIDS.API,
  //   label: "MENUITEMS.INTEGRATIONANDAUTOMATION.LIST.API",
  //   icon: 'integration_instructions',
  //   icon_color: "#e78775",
  //   link: "/api",
  // },
  // {
  //   id: MENUIDS.CONTENTMANGER,
  //   label: "MENUITEMS.CONTENTMANGER.TEXT",
  //   icon: "mdi mdi-view-module",
  //   subItems: [
  //     {
  //       id: MENUIDS.PAGES,
  //       label: "MENUITEMS.CONTENTMANGER.LIST.PAGES",
  //       link: "/pages",
  //       parentId: MENUIDS.CONTENTMANGER,
  //     },
  //     {
  //       id: MENUIDS.ARTICLE,
  //       label: "MENUITEMS.CONTENTMANGER.LIST.ARTICLE",
  //       link: "/article",
  //       parentId: MENUIDS.CONTENTMANGER,
  //     },
  //   ],
  // },
  {
    isTitle: true,
    label: "Settings",
  },
  {
    id: MENUIDS.SETTINGS,
    label: "Settings",
    icon: "settings",
    icon_color: "#2b86f3",
    link: "/settings",
    bitOffset: PermissionBits.Settings,
  },
  // {
  //   id: MENUIDS.GENERALSETTINGS,
  //   label: "General Settings",
  //   icon: "settings",
  //   icon_color: "#2b86f3",
  //   subItems: [
  //     // {
  //     //   id: MENUIDS.SETTINGSLIST,
  //     //   label: "MENUITEMS.SETTINGS.LIST.CUSTOMFIELDS",
  //     //   link: "/custom-fields",
  //     //   parentId: MENUIDS.SETTINGS,
  //     // },
  //     {
  //       id: MENUIDS.DEFAULTSETTINGS,
  //       label: "Default Settings",
  //       link: "/commerce-settings",
  //       parentId: MENUIDS.GENERALSETTINGS,
  //     },
  //     {
  //       id: MENUIDS.TAXSETTING,
  //       label: "Tax Settings",
  //       link: "/tax-settings",
  //       parentId: MENUIDS.GENERALSETTINGS,
  //     },
  //     {
  //       id: MENUIDS.SHIPPINGSETTINGS,
  //       label: "Shipping Rates",
  //       link: "/shipping-settings",
  //       parentId: MENUIDS.GENERALSETTINGS,
  //     },
  //   ]
  // },
  // {
  //   id: MENUIDS.CHATSETTINGS,
  //   label: "Chat Settings",
  //   icon: "sell",
  //   icon_color: "#f7a01a",
  //   subItems: [
  //     {
  //       id: MENUIDS.USERSTAGS,
  //       label: "App User Tags",
  //       link: "/tags",
  //       parentId: MENUIDS.CHATSETTINGS,
  //     }
  //   ],
  // },
  // {
  //   id: MENUIDS.SIGNUPSETTINGS,
  //   label: "Signup Settings",
  //   icon: "login",
  //   icon_color: "#eb8cd2",
  //   subItems: [
  //     {
  //       id: MENUIDS.SIGNUPFILTER,
  //       label: "MENUITEMS.SETTINGS.LIST.SIGNUPFILTER",
  //       link: "/signup-filter",
  //       parentId: MENUIDS.SIGNUPSETTINGS,
  //     },
  //     {
  //       id: MENUIDS.WHITELISTANDBLACKLIST,
  //       label: "MENUITEMS.SETTINGS.LIST.WHITELISTANDBLACKLIST",
  //       link: "/whitelist-and-blacklist",
  //       parentId: MENUIDS.SIGNUPSETTINGS,
  //     },
  //   ],
  // },
  // {
  //   id: MENUIDS.TEMPLATE,
  //   label: "Admin",
  //   icon: 'groups',
  //   icon_color: "#fd9452",
  //   link: "/template",
  // },
  {
    id: MENUIDS.BULLKUPLOAD,
    label: "Bullk Upload",
    icon: "cloud_upload",
    icon_color: "#fd9452",
    link: "/bullkUpload",
  },

];
